import axiosInstance from "../../api/axiosInstance";

// Admin support-ticket endpoints. All responses are wrapped as { ok, data },
// so callers read `res.data.data`. Mounted under /api/admin/tickets.

// Empty filters are left out; axios encodes the rest (a search like "a&b"
// reaches the server intact).
export const fetchTicketsAPI = ({
  status = "",
  category = "",
  search = "",
  rating = "",
  page = 1,
  limit = 20,
} = {}) => {
  const params = { page, limit };
  if (status) params.status = status;
  if (category) params.category = category;
  if (search) params.search = search;
  if (rating) params.rating = rating;
  return axiosInstance.get("admin/tickets", { params });
};

export const fetchTicketAPI = (ticketId) => {
  return axiosInstance.get(`admin/tickets/${ticketId}`);
};

export const fetchTicketMessagesAPI = (ticketId, params = {}) => {
  return axiosInstance.get(`admin/tickets/${ticketId}/messages`, { params });
};

export const sendTicketMessageAPI = (ticketId, body) => {
  // body: { message?, imageIds?, clientMessageId }
  return axiosInstance.post(`admin/tickets/${ticketId}/messages`, body);
};

export const setTicketStatusAPI = (ticketId, status) => {
  return axiosInstance.patch(`admin/tickets/${ticketId}/status`, { status });
};

export const markTicketReadByAdminAPI = (ticketId) => {
  return axiosInstance.patch(`admin/tickets/${ticketId}/read`);
};

// Backend proxy upload: send the files as multipart FormData; the backend
// uploads to S3 and returns [{ imageId, path }]. The axios interceptor strips
// the Content-Type header for FormData so the boundary is set correctly.
export const uploadTicketAttachmentsAPI = (files) => {
  const formData = new FormData();
  files.forEach((f) => formData.append("images", f));
  return axiosInstance.post(`admin/tickets/attachments/upload`, formData);
};
